import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
/*ElementUI*/
import ele from "element-ui";

/*********************    前台页面   ************************/
import base from "../views/show/base.vue";
import Home from "../views/show/index.vue";
import Popularity from "../views/show/popularity.vue";
import Account from "../views/show/account.vue";
import AccountInfo from "../views/show/account-info.vue";
import Login from "../views/show/login.vue";
import Forgot from "../views/show/forgot.vue";
import UniversityUser from "../views/show/university-user.vue";
import Department from "../views/show/department.vue";
import Role from "../views/show/role.vue";
import School from "../views/show/school.vue";
import College from "../views/show/college.vue";
import Group from "../views/show/group.vue";
import AccountAdd from "../views/show/account-add.vue";
import RenewalAdd from "../views/show/renewal-add";
import User from "../views/show/user";
import ContentAd from "../views/show/content/ad.vue";
import ArticleCategory from "../views/show/content/article-category.vue";
import ContentArticle from "../views/show/content/article.vue";
import Student from "../views/show/student.vue";
import PackageDefinition from "../views/show/packageDefinition.vue";
import SubscriptionHistory from "../views/show/subscriptionHistory.vue";
import InvoiceManagement from "../views/show/invoiceManagement.vue";
import WelcomeMessage from "../views/show/welcomeMessage.vue";
import PermissionRequest from "../views/show/PermissionRequest.vue";
import Benefits from "../views/show/benefits.vue";

/*********************    End   ************************/

// 防止重复点击报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => {});
};
Vue.use(VueRouter);

const routes = [
  /**
   * @type: show 代表前台页面
   */
  {
    path: "/",
    name: "root",
    redirect: "/index",
    component: base,
    meta: {
      title: "首頁",
      type: "show",
    },
    children: [
      {
        path: "/index",
        name: "首頁",
        component: Home,
        meta: {
          title: "首頁",
          type: "show",
        },
      },
      {
        path: "/popularity",
        name: "人氣趨勢追蹤",
        component: Popularity,
        meta: {
          title: "人氣趨勢追蹤",
          type: "show",
        },
      },
      {
        path: "/account",
        name: "帳號與個人資料",
        component: Account,
        meta: {
          title: "帳號與個人資料",
          type: "show",
        },
      },
      {
        path: "/account-info",
        name: "個人資料",
        component: AccountInfo,
        meta: {
          title: "個人資料",
          type: "show",
        },
      },
      {
        path: "/university-user",
        name: "大學會員管理",
        component: UniversityUser,
        meta: {
          title: "大學會員管理",
          type: "show",
        },
      },
      {
        path: "/User",
        name: "個人會員管理",
        component: User,
        meta: {
          title: "個人會員管理",
          type: "show",
        },
      },
      {
        path: "/content/ad",
        name: "廣告管理",
        component: ContentAd,
        meta: { title: "廣告管理", type: "show" },
      },
      {
        path: "/content/article-category",
        name: "分類管理",
        component: ArticleCategory,
        meta: { title: "分類管理", type: "show" },
      },
      {
        path: "/content/article",
        name: "文章管理",
        component: ContentArticle,
        meta: { title: "文章管理", type: "show" },
      },

      {
        path: "/account-add",
        name: "加購管理",
        component: AccountAdd,
        meta: {
          title: "加購管理",
          type: "show",
        },
      },
      {
        path: "/renewal-add",
        name: "續約管理",
        component: RenewalAdd,
        meta: {
          title: "續約管理",
          type: "show",
        },
      },

      {
        path: "/department",
        name: "部門管理",
        component: Department,
        meta: {
          title: "部門管理",
          type: "show",
        },
      },
      {
        path: "/role",
        name: "角色管理",
        component: Role,
        meta: {
          title: "角色管理",
          type: "show",
        },
      },
      {
        path: "/school",
        name: "學校管理",
        component: School,
        meta: {
          title: "學校管理",
          type: "show",
        },
      },
      {
        path: "/college",
        name: "學院與學系管理",
        component: College,
        meta: {
          title: "學院與學系管理",
          type: "show",
        },
      },
      {
        path: "/group",
        name: "校系學群",
        component: Group,
        meta: {
          title: "校系學群",
          type: "show",
        },
      },
      {
        path: "/student",
        name: "學生管理",
        component: Student,
        meta: {
          title: "學生管理",
          type: "show",
        },
      },
      {
        path: "/packageDefinition",
        name: "套餐定義",
        component: PackageDefinition,
        meta: {
          title: "套餐定義",
          type: "show",
        },
      },
      {
        path: "/subscriptionHistory",
        name: "訂閱记录",
        component: SubscriptionHistory,
        meta: {
          title: "訂閱记录",
          type: "show",
        },
      },
      {
        path: "/invoiceManagement",
        name: "發票管理",
        component: InvoiceManagement,
        meta: {
          title: "發票管理",
          type: "show",
        },
      },
      {
        path: "/welcomeMessage",
        name: "歡迎語管理",
        component: WelcomeMessage,
        meta: {
          title: "歡迎語管理",
          type: "show",
        },
      },
      {
        path: "/permissionRequest",
        name: "權限領取管理",
        component: PermissionRequest,
        meta: {
          title: "權限領取管理",
          type: "show",
        },
      },
      {
        path: "/benefits",
        name: "權益每日用量",
        component: Benefits,
        meta: {
          title: "權益每日用量",
          type: "show",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "登入",
    component: Login,
    meta: {
      title: "登入",
      type: "login",
    },
  },
  {
    path: "/forgot",
    name: "忘記密碼",
    component: Forgot,
    meta: {
      title: "忘記密碼",
      type: "forgot",
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0,
    };
  },
});

// 路由守卫
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title =
    (to.meta.title ? to.meta.title + "-" : "") + "大學問-大學問總管理中心";
  // 判断Token是否存在
  let token = localStorage.getItem("Authorization");
  if (to.meta.type == "member") {
    localStorage.setItem("backurl", to.fullPath);
  }
  if (to.meta.type == "member" || to.meta.type == "diy") {
    if (token) {
      next();
    } else {
      ele.Message({
        message: "请先登录",
        type: "warning",
      });
      next("/");
    }
  } else {
    next();
  }
});
export default router;
